export default __webpack_public_path__ + "media/images/mailer/icon_person_add-44d0a8dfa7dce95be5f6e3cfe0cdd133.png";